class MaximumFavoritesError extends Error {
  constructor(message) {
    super(message)
    this.name = 'MaximumFavorites'
  }
}

class FavoriteAssets {
  #favoriteAssetsAtom
  #maximumFavoritesCount

  constructor({ favoriteAssetsAtom, config = Object.create(null) }) {
    this.#favoriteAssetsAtom = favoriteAssetsAtom
    this.#maximumFavoritesCount = config.maximumFavoritesCount || Infinity
  }

  #assertMaximumFavorites = (newValue) => {
    const favorites = Object.values(newValue).filter((v) => !!v)

    if (favorites.length > this.#maximumFavoritesCount) throw new MaximumFavoritesError()
  }

  #setValue = async (assetNames, value) => {
    const currentFavorites = await this.#favoriteAssetsAtom.get()
    const changes = assetNames.map((assetName) => ({ [assetName]: value }))
    const newValue = Object.assign(Object.create(null), currentFavorites, ...changes)

    this.#assertMaximumFavorites(newValue)

    await this.#favoriteAssetsAtom.set(newValue)
  }

  favorite = async (assetNames) => this.#setValue(assetNames, true)

  unfavorite = async (assetNames) => this.#setValue(assetNames, false)
}

const createFavoriteAssetsModule = (args) => new FavoriteAssets({ ...args })

const favoriteAssetsModuleDefinition = {
  id: 'favoriteAssets',
  type: 'module',
  factory: createFavoriteAssetsModule,
  dependencies: ['favoriteAssetsAtom', 'config'],
  public: true,
}

export default favoriteAssetsModuleDefinition
